export default __webpack_public_path__ + "ed49088eb627c1c0155d8b711767f15c.woff";